import { Optimizing } from '../types/coreEntitiesTypes'

export enum OptimizingDataType {
  Request = 'request',
  Response = 'response',
  Error = 'error'
}

export enum OptimizingType {
  PTV = 'PTV',
  GRAPHHOPPER = 'GRAPHHOPPER',
  KARDINAL = 'KARDINAL',
  HERE = 'HERE',
  HEXALY = 'HEXALY',
  HEXALY_CLOUD = 'HEXALY_CLOUD'
}

export const optimizingTypeFromString = (optimizingTypeString: string | null): OptimizingType | undefined => {
  return Object.values(OptimizingType).find((v) => v === optimizingTypeString)
}

export const getSelectedOptimizingType = (): OptimizingType =>
  optimizingTypeFromString(localStorage.getItem('optimizingEngine')) ?? OptimizingType.GRAPHHOPPER

const PROVIDER_ENGINES = [
  OptimizingType.KARDINAL,
  OptimizingType.HERE,
  OptimizingType.HEXALY,
  OptimizingType.HEXALY_CLOUD
]

export const isProviderEngine = (type: OptimizingType): boolean => PROVIDER_ENGINES.includes(type)

// A choice saved while the provider engines were offered falls back to GraphHopper once they are not
export const usableOptimizingType = (selected: OptimizingType, providerEnginesEnabled: boolean): OptimizingType =>
  !providerEnginesEnabled && isProviderEngine(selected) ? OptimizingType.GRAPHHOPPER : selected

// Kardinal, HERE, Hexaly and Hexaly Cloud only plan several routes at once; the backend plans a single route with GraphHopper
export const getSelectedSingleRouteOptimizingType = (): OptimizingType => {
  const selected = getSelectedOptimizingType()
  return isProviderEngine(selected) ? OptimizingType.GRAPHHOPPER : selected
}

export const SOLVE_TIME_LIMIT_SECONDS = { min: 10, max: 2700 }

export const isValidSolveTimeLimit = (timeLimitInSeconds: string): boolean => {
  const seconds = Number(timeLimitInSeconds)
  return (
    timeLimitInSeconds === '' ||
    (Number.isInteger(seconds) && seconds >= SOLVE_TIME_LIMIT_SECONDS.min && seconds <= SOLVE_TIME_LIMIT_SECONDS.max)
  )
}

export const solveBudgetSecondsFor = (engine: OptimizingType, timeLimitInSeconds: string): number | undefined =>
  isProviderEngine(engine) && timeLimitInSeconds !== '' ? Number(timeLimitInSeconds) : undefined

export const showStopsFromLocalStorage = (showStopsString: string | null): boolean | undefined => {
  if (showStopsString === 'true') {
    return true
  } else if (showStopsString === 'false') {
    return false
  } else {
    return undefined
  }
}

export const numberOfShipments = (optimizing: Optimizing) =>
  optimizing.get('consignmentIds') !== null ? optimizing.get('consignmentIds')?.size : optimizing.get('orderIds')?.size

export const hasOptimizingStats = (optimizing: Optimizing) =>
  optimizing.get('status') === 'FINISHED' && optimizing.get('containResponse')
